export const SET_PROFILE_LOADER = "SET_PROFILE_LOADER"
export const SET_PROFILE_DATA = "SET_PROFILE_DATA"
